import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IForecastForReceiptRepository } from '@/coreInfrastructureModule/interfaces/IForecastForReceiptManage';
import { DeleteForecastForReceiptAdapter } from '../adapter/deleteForecastForReceiptAdapter';

/**
 * 受領用内示を削除するUseCase
 */
export class DeleteForecastForReceiptUseCase {
  private repository: IForecastForReceiptRepository;

  /**
   * @param repository - 受領用内示情報の永続化の責務を負うクラス
   */
  constructor(repository: IForecastForReceiptRepository) {
    this.repository = repository;
  }

  /**
   * 受領用内示を削除する
   * @param forecastForReceiptId - 受領用内示ID
   */
  public Execute = async (forecastForReceiptId: string): Promise<INetworkResult<void, Error>> => {
    try {
      const request = DeleteForecastForReceiptAdapter.adaptForRequest(forecastForReceiptId);
      const result = await this.repository.deleteForecastForReceipt(request);

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('追加に失敗しました'),
        },
      };
    }
  };
}
